import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Download, Mail } from "lucide-react";
import api, { fmtErr } from "../../lib/api";

export const NewsletterAdmin = () => {
  const [data, setData] = useState({ subscribers: [], total: 0, active: 0 });
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = () =>
    api.get("/admin/newsletter").then((res) => setData(res.data)).finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    if (!window.confirm("Remover este subscritor?")) return;
    try {
      await api.delete(`/admin/newsletter/${id}`);
      toast.success("Subscritor removido.");
      load();
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail));
    }
  };

  const exportCsv = async () => {
    try {
      const res = await api.get("/admin/newsletter/export", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = "newsletter_innpact.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail));
    }
  };

  const filtered = data.subscribers.filter(
    (s) =>
      s.email.toLowerCase().includes(q.toLowerCase()) ||
      (s.name || "").toLowerCase().includes(q.toLowerCase())
  );

  if (loading) return <p className="label-editorial text-black/40">A carregar…</p>;

  return (
    <div data-testid="newsletter-panel" className="space-y-6">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        <div className="bg-white border border-black/5 p-6">
          <p className="label-editorial text-black/40 mb-2">Total</p>
          <p className="font-display text-4xl">{data.total}</p>
        </div>
        <div className="bg-white border border-black/5 p-6">
          <p className="label-editorial text-black/40 mb-2">Ativos</p>
          <p className="font-display text-4xl text-green-700">{data.active}</p>
        </div>
        <div className="bg-white border border-black/5 p-6">
          <p className="label-editorial text-black/40 mb-2">Cancelados</p>
          <p className="font-display text-4xl text-black/30">{data.total - data.active}</p>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <input
          data-testid="newsletter-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Pesquisar email ou nome…"
          className="flex-1 min-w-[200px] bg-white border border-black/15 px-3 py-2.5 text-sm font-light focus:outline-none focus:border-black"
        />
        <button
          data-testid="newsletter-export-btn"
          onClick={exportCsv}
          className="flex items-center gap-2 border border-black/20 px-5 py-2.5 hover:border-black transition-colors text-sm"
        >
          <Download size={15} /> Exportar CSV
        </button>
      </div>

      <div className="bg-white border border-black/5 overflow-x-auto">
        <table className="w-full text-sm font-light min-w-[560px]">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-black/40 border-b border-black/10">
              <th className="py-3 px-4">Email</th>
              <th className="py-3 px-4">Nome</th>
              <th className="py-3 px-4">Estado</th>
              <th className="py-3 px-4">Data</th>
              <th className="py-3 px-4"></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((s) => (
              <tr key={s.id} data-testid={`newsletter-row-${s.id}`} className="border-b border-black/5 last:border-0">
                <td className="py-3 px-4 flex items-center gap-2">
                  <Mail size={13} className="text-black/30" /> {s.email}
                </td>
                <td className="py-3 px-4 text-black/60">{s.name || "—"}</td>
                <td className="py-3 px-4">
                  {s.status === "active" ? (
                    <span className="text-xs px-2 py-0.5 bg-green-50 text-green-700">Ativo</span>
                  ) : (
                    <span className="text-xs px-2 py-0.5 bg-black/5 text-black/50">Cancelado</span>
                  )}
                </td>
                <td className="py-3 px-4 text-black/50">{(s.created_at || "").slice(0, 10)}</td>
                <td className="py-3 px-4 text-right">
                  <button
                    data-testid={`newsletter-delete-${s.id}`}
                    onClick={() => remove(s.id)}
                    className="p-1.5 hover:bg-black/5 text-red-600"
                    aria-label="Remover"
                  >
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={5} className="py-8 text-center text-black/40 font-light">
                  Sem subscritores.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewsletterAdmin;
